import React from 'react';

const Date = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.9321 2.32495H14.1821V1.57495C14.1821 1.37604 14.1031 1.18527 13.9624 1.04462C13.8218 0.903969 13.631 0.824951 13.4321 0.824951C13.2332 0.824951 13.0424 0.903969 12.9018 1.04462C12.7611 1.18527 12.6821 1.37604 12.6821 1.57495V2.32495H5.28711V1.57495C5.28711 1.37604 5.20809 1.18527 5.06744 1.04462C4.92679 0.903969 4.73602 0.824951 4.53711 0.824951C4.3382 0.824951 4.14743 0.903969 4.00678 1.04462C3.86613 1.18527 3.78711 1.37604 3.78711 1.57495V2.32495H3.03711C2.63928 2.32495 2.25775 2.48299 1.97645 2.76429C1.69514 3.0456 1.53711 3.42713 1.53711 3.82495V15.675C1.53711 16.0728 1.69514 16.4543 1.97645 16.7356C2.25775 17.0169 2.63928 17.175 3.03711 17.175H14.9321C15.3299 17.175 15.7115 17.0169 15.9928 16.7356C16.2741 16.4543 16.4321 16.0728 16.4321 15.675V3.80995C16.4282 3.41473 16.2684 3.03704 15.9875 2.75897C15.7066 2.48091 15.3273 2.32493 14.9321 2.32495ZM14.1821 15.675H3.80961C3.6107 15.675 3.41993 15.5959 3.27928 15.4553C3.13863 15.3146 3.05961 15.1239 3.05961 14.925V5.99995H14.9321V14.9325C14.9302 15.1288 14.8513 15.3165 14.7125 15.4553C14.5737 15.5941 14.3859 15.673 14.1896 15.675H14.1821Z"
      fill="var(--PRIMARY)"
    />
  </svg>
);

export default Date;
